module.exports = __webpack_public_path__ + "static/media/canal-03.e6a1a1d9.png";